//#region src/index.ts
var TRUTHY_STRINGS = [
	"true",
	"b",
	"c",
	"new",
	"enabled"
];
var Experiments = class {
	experiments;
	constructor(experiments) {
		this.experiments = experiments;
	}
	isOpen(name) {
		return isExperimentOpen(this.experiments, name);
	}
	getValue(name) {
		return getExperimentValue(this.experiments, name);
	}
};
function getExperimentValue(experimentsObject, experimentName) {
	return experimentsObject[experimentName];
}
function isExperimentOpen(experimentsObject, experimentName) {
	const value = getExperimentValue(experimentsObject, experimentName);
	if (value === true) return true;
	if (typeof value === "string") return TRUTHY_STRINGS.includes(value.toLowerCase());
	return false;
}
//#endregion
export { Experiments, getExperimentValue, isExperimentOpen };

//# sourceMappingURL=index.mjs.map